/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IncomeViewModel
 */
export interface IncomeViewModel {
    /**
     * 
     * @type {number}
     * @memberof IncomeViewModel
     */
    grossAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof IncomeViewModel
     */
    frequency?: string;
    /**
     * 
     * @type {Date}
     * @memberof IncomeViewModel
     */
    nextPaymentDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IncomeViewModel
     */
    growthRateDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof IncomeViewModel
     */
    growthRate?: number;
    /**
     * 
     * @type {Date}
     * @memberof IncomeViewModel
     */
    revisionDate?: Date;
}

/**
 * Check if a given object implements the IncomeViewModel interface.
 */
export function instanceOfIncomeViewModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function IncomeViewModelFromJSON(json: any): IncomeViewModel {
    return IncomeViewModelFromJSONTyped(json, false);
}

export function IncomeViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): IncomeViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'grossAmount': !exists(json, 'GrossAmount') ? undefined : json['GrossAmount'],
        'frequency': !exists(json, 'Frequency') ? undefined : json['Frequency'],
        'nextPaymentDate': !exists(json, 'NextPaymentDate') ? undefined : (new Date(json['NextPaymentDate'])),
        'growthRateDate': !exists(json, 'GrowthRateDate') ? undefined : (new Date(json['GrowthRateDate'])),
        'growthRate': !exists(json, 'GrowthRate') ? undefined : json['GrowthRate'],
        'revisionDate': !exists(json, 'RevisionDate') ? undefined : (new Date(json['RevisionDate'])),
    };
}

export function IncomeViewModelToJSON(value?: IncomeViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'GrossAmount': value.grossAmount,
        'Frequency': value.frequency,
        'NextPaymentDate': value.nextPaymentDate === undefined ? undefined : (value.nextPaymentDate.toISOString()),
        'GrowthRateDate': value.growthRateDate === undefined ? undefined : (value.growthRateDate.toISOString()),
        'GrowthRate': value.growthRate,
        'RevisionDate': value.revisionDate === undefined ? undefined : (value.revisionDate.toISOString()),
    };
}

